import React from 'react'
import "./TRCEfficientServicesBanner.css"
import "./ResponsiveTRCEfficientServicesBanner.css"
const host = process.env.REACT_APP_API_SERVER;
const TRCEfficientServicesBanner = (trcEfficientData) => {
    return (
        <>
            <section className='trc-energy-banner-section'>
                <div className="col-md-12 text-start">
                    <div className="business-heading text-start">
                        <img src={trcEfficientData?.trcEfficientData?.banner_image ? `${host}/${trcEfficientData?.trcEfficientData?.banner_image}` : "./images/global-energy/trc-banner.png"} alt="" className='img-fluid' />
                    </div>
                </div>
            </section>
        </>
    )
}

export default TRCEfficientServicesBanner